import Vue from 'vue';
import Vuex from 'vuex';
import { appStore } from './modules/App/app';
import { authStore } from './modules/Auth/auth'
import { companyStore } from './modules/Company/company';
import { notificationsStore } from './modules/Notifications/notifications';
import { installationsStore } from './modules/Installations/installations';
import { parametersStore } from './modules/Parameters/parameters';
import { pvsystStore } from './modules/Pvsyst/pvsyst';
import { selectedSitesStore } from './modules/SelectionSite/selectionsite';
import { treeSelectedSitesStore } from './modules/TreeSelectionSite/treeSelectionSite';
import { treeSelectedHeliocleanSitesStore } from './modules/TreeSelectionHeliocleanSite/treeSelectionHeliocleanSite';
Vue.use(Vuex);

import createPersistedState from "vuex-persistedstate";

const store = new Vuex.Store({
  modules: {
    appStore,
    authStore,
    companyStore,
    notificationsStore,
    installationsStore,
    parametersStore,
    pvsystStore,
    selectedSitesStore,
    treeSelectedSitesStore,
    treeSelectedHeliocleanSitesStore

  },
  strict: false,
  plugins: [createPersistedState()],
});

export default store;
